import React, { useEffect, useState, useCallback } from "react";
import Editor from "../../../../../../components/editor";
import { useAppServices } from "../../../../../../hook/services";
import { toast } from "react-toastify";

const GetStarted = ({ app, handleRefresh }) => {
  const AppService = useAppServices();
  const [editorContent, setEditorContent] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(false);

  // Load existing data on mount/update
  useEffect(() => {
    if (app?.getStarted) {
      setEditorContent(app.getStarted.content || "");
      setVideoUrl(app.getStarted.video || "");
    }
  }, [app]);

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      // Basic validation
      if (!videoUrl && !editorContent) {
        toast.error("Please provide a video URL or some content.");
        return;
      }

      const payload = {
        _id: app._id,
        getStarted: {
          video: videoUrl,
          content: editorContent,
        },
      };

      try {
        setLoading(true);
        const { response, error } = await AppService.apps.update({ payload });

        if (error) throw error;

        if (response) {
          const hasExistingData =
            app?.getStarted?.video || app?.getStarted?.content;
          toast.success(
            hasExistingData
              ? "Data updated successfully"
              : "Data saved successfully"
          );
          handleRefresh();
        }
      } catch (err) {
        console.error("Error updating GetStarted:", err);
        toast.error("Failed to save data. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [
      app?._id,
      app?.getStarted,
      videoUrl,
      editorContent,
      AppService,
      handleRefresh,
    ]
  );

  return (
    <div className="max-w-2xl mx-auto p-5 bg-white shadow rounded-lg">
      <h1 className="text-2xl font-bold mb-4">Get Started</h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Video URL Input */}
        <div>
          <label className="d-block font-medium mb-1">Video URL</label>
          <input
            type="url"
            placeholder="Enter video URL"
            value={videoUrl}
            onChange={(e) => setVideoUrl(e.target.value)}
            className="w-full border px-3 py-2 rounded-md"
          />
        </div>

        {/* Content Editor */}
        <div>
          <label className="d-block font-medium mb-1">Content</label>
          <Editor
            data={editorContent}
            handleChange={(value) => setEditorContent(value)}
          />
        </div>

        {/* Submit */}
        <div className="d-flex justify-content-end mt-4">
          <button type="submit" className="btn btn-success" disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default GetStarted;
